import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { complexValidationFromServer, ServerValidationErrors, ServerValidationTypes } from 'app/infrastructure/data/validation';
import { DefaultFilterValidation } from '../types-store';

export const mapFilterValidation = (
  validationMessages: ServerValidationTypes
): { [domainId: number]: DefaultFilterValidation } => {

  const groupedValidation = Array.isArray(validationMessages)
    ? validationMessages.reduce(
      (messages, message) => {

        if (typeof message === 'object' && isDefinedIncludingZero(message.parameters?.domain)) {

          const currentServerErrors = messages[message.parameters.domain] || {};

          const { domain: _, ...errorValues } = message.parameters;
          const errorKeys = Object.keys(errorValues);

          return {
            ...messages,
            [message.parameters.domain]: errorKeys.reduce((result, key) => ({
              ...result,
              [key]: [
                ...(result[key] || []),
                message
              ]
            }), currentServerErrors)
          };
        }

        return messages;
      }, {} as { [domainId: number]: ServerValidationErrors })
    : {};

  return Object.keys(groupedValidation).reduce(
    (result, key) => ({
      ...result,
      [key]: complexValidationFromServer(groupedValidation[key])
    }), {} as { [domainId: number]: DefaultFilterValidation }
  );
};
